import styled from '@emotion/styled';
import { IBoxProps } from './types';
import { css } from '@emotion/react';

export const Container = styled.button<IBoxProps>`
  display: flex;
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  transition: all 0.5s ease-in-out;

  ${({ disabled }) => {
    if (disabled) {
      return css`
        cursor: no-drop;
        opacity: 0.5;
      `;
    }
  }}
  &:hover {
    ${({ isNotHover }) => {
      if (!isNotHover) {
        return css`
          opacity: 0.8;
          box-shadow: 0 -5px 30px #0d86ff3b, 0 5px 30px #44d78961;
        `;
      }
    }}
  }
`;
